import "@frontend/css/app.scss";
import "@el7ven/cookie-kit/styles";
import { CookieConsent } from "@el7ven/cookie-kit/react";
import { createAnalyticsManager } from "@el7ven/cookie-kit/analytics";
import ScrollToTopButton from "@frontend/js/Components/Site/ScrollToTopButton/ScrollToTopButton";
import TawkChat from "@frontend/js/Components/Shared/TawkChat/TawkChat";
import Header from "@frontend/js/Components/Site/Header/Header";
import Footer from "@frontend/js/Components/Site/Footer/Footer";
import useT from "@frontend/js/hooks/useT";
import { usePage } from "@inertiajs/react";
import { useEffect } from "react";

export default function SiteLayout({ children }) {
    const { props } = usePage();
    const locale = props?.currentLocale || "ro";
    const { t } = useT("cookie_consent");

    useEffect(() => {
        const ids = window.__ANALYTICS_IDS__;
        if (!ids) return;
        const analytics = createAnalyticsManager({
            gtm:               ids.gtm               || undefined,
            ga4:               ids.ga4               || undefined,
            metaPixel:         ids.metaPixel         || undefined,
            yandexMetrica:     ids.yandexMetrica     || undefined,
            googleRemarketing: ids.googleRemarketing || undefined,
        });
        analytics.init();
        analytics.connectToCookieConsent();
    }, []);

    const localeSegment = typeof window !== "undefined"
        ? window.location.pathname.split("/").filter(Boolean)[0]
        : locale;
    const privacyUrl = `/${localeSegment}/privacy-policy`;

    return (
        <div>
            <Header />
            <main>
                <div style={{ position: "relative" }}>
                    {children}
                    <ScrollToTopButton />
                </div>
            </main>
            <Footer />
            <TawkChat />
            <CookieConsent
                lang={locale}
                mode="gdpr"
                position="center"
                categories={["necessary", "analytics", "marketing", "preferences"]}
                config={{
                    categories: {
                        necessary:   { required: true,  enabled: true,  disabled: true,  name: t("necessary_label"),   description: t("necessary_description")   },
                        analytics:   { required: false, enabled: false, disabled: false, name: t("analytics_label"),   description: t("analytics_description")   },
                        marketing:   { required: false, enabled: false, disabled: false, name: t("marketing_label"),   description: t("marketing_description")   },
                        preferences: { required: false, enabled: false, disabled: false, name: t("preferences_label"), description: t("preferences_description") },
                    },
                    policies: {
                        privacy: privacyUrl,
                        cookies: privacyUrl,
                    },
                    texts: {
                        gdpr: {
                            title:    t("title"),
                            message:  t("message"),
                            accept:   t("accept_all"),
                            reject:   t("reject_all"),
                            settings: t("settings"),
                        },
                        buttons: {
                            acceptAll:       t("accept_all"),
                            rejectAll:       t("reject_all"),
                            acceptSelection: t("accept_selection"),
                        },
                        settings: {
                            title:   t("settings_title"),
                            tabs:    { privacy: t("privacy_tab") },
                            privacy: { intro: t("privacy_intro") },
                            links: {
                                moreInfo:      t("more_info"),
                                cookieDetails: t("cookie_details"),
                            },
                        },
                        categories: {
                            necessary:   { label: t("necessary_label"),   description: t("necessary_description")   },
                            analytics:   { label: t("analytics_label"),   description: t("analytics_description")   },
                            marketing:   { label: t("marketing_label"),   description: t("marketing_description")   },
                            preferences: { label: t("preferences_label"), description: t("preferences_description") },
                        },
                    },
                }}
            />
        </div>
    );
}
